import { useState } from "react";
import { App, Button } from "antd";
import { edge, storageUrl } from "../lib/supabase.js";
export async function downloadPrivateFile(file) {
  if (!file.id)
    throw new Error("파일 정보가 없습니다. 목록을 새로고침해 주세요.");
  const { signedUrl } = await edge("file-download", { fileId: file.id });
  const response = await fetch(storageUrl(signedUrl));
  if (!response.ok)
    throw new Error("파일을 다운로드하지 못했습니다. 다시 시도해 주세요.");
  const url = URL.createObjectURL(await response.blob());
  const link = document.createElement("a");
  link.href = url;
  link.download = file.name;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export function FileDownload({ file }) {
  const [loading, setLoading] = useState(false);
  const { message } = App.useApp();
  return (
    <Button
      loading={loading}
      onClick={async () => {
        setLoading(true);
        try {
          await downloadPrivateFile(file);
        } catch (error) {
          message.error(error.message);
        } finally {
          setLoading(false);
        }
      }}
    >
      {file.name}
    </Button>
  );
}
